import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function CookiePolicy() {
  return (
    <StaticPage title="Cookie Policy" subtitle="How RentalX uses cookies and similar technologies.">
      <Section title="What Are Cookies?">
        <p>Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, keep you logged in, and understand how you use the site.</p>
      </Section>

      <Section title="Cookies We Use">
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-[#094f6f] text-white">
                <th className="p-3 text-left rounded-tl-lg">Category</th>
                <th className="p-3 text-left">Purpose</th>
                <th className="p-3 text-left rounded-tr-lg">Duration</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Essential', 'Required for the site to function — login sessions, security tokens', 'Session'],
                ['Preferences', 'Remember your settings such as language and search filters', '1 year'],
                ['Analytics', 'Understand how visitors use RentalX (page views, time on site) via anonymised data', '2 years'],
                ['Marketing', 'Deliver relevant advertising on other platforms (can be disabled)', '1 year'],
              ].map(([cat, purpose, dur], i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                  <td className="p-3 font-medium text-gray-800">{cat}</td>
                  <td className="p-3 text-gray-600">{purpose}</td>
                  <td className="p-3 text-gray-600">{dur}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section title="Managing Cookies">
        <p>You can control cookies through your browser settings. Note that disabling essential cookies will prevent you from logging in to RentalX.</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#094f6f] underline">Chrome cookie settings</a></li>
          <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471" target="_blank" rel="noopener noreferrer" className="text-[#094f6f] underline">Safari cookie settings</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer" className="text-[#094f6f] underline">Firefox cookie settings</a></li>
        </ul>
      </Section>

      <Section title="Contact">
        <p>Questions about our cookie use? Email <strong>privacy@rentalx.com.au</strong>.</p>
        <p className="text-sm text-gray-500 mt-2">Last updated: February 2026</p>
      </Section>
    </StaticPage>
  );
}
